import React, { useContext } from 'react';
import { TopNav } from '@eposnow/ui-core';
import { useTheme } from '@mui/material/styles';
import { UIContext } from '../context/UIContext';
import { UserContext } from '../context/UserContext';
import { ENVIRONMENT_KEY, MANAGE_ACCOUNT_LINK_KEY } from '../localStorageKeys';

const NavigationComponents = () => {
  const { isMobile, animationsDisabled } = useContext(UIContext);
  const project = 'onboardingwizard';
  const theme = useTheme();
  const { user, locale } = useContext(UserContext);
  const version =
    localStorage.getItem(ENVIRONMENT_KEY) === 'test'
      ? `${process.env.REACT_APP_BUILD_VERSION}-test`
      : process.env.REACT_APP_BUILD_VERSION;

  return (
    <TopNav
      openSideNav={false}
      showSideNav={false}
      animationsDisabled={animationsDisabled}
      theme={theme}
      isMobile={isMobile}
      toggleDrawer={undefined}
      user={{ fullName: user.fullName, email: user.email }}
      appVersion={version}
      locale={locale}
      currentProject={project}
      hideAppsAndUserMenus
      accountUrl={localStorage.getItem(MANAGE_ACCOUNT_LINK_KEY)}
    />
  );
};

export default NavigationComponents;
